import React from 'react';
import Badge from '@cloudscape-design/components/badge';
import SpaceBetween from '@cloudscape-design/components/space-between';
import Box from '@cloudscape-design/components/box';
import { GroupResult, RemapStatus } from '../services/api';

export interface AccountTypeSelectorProps {
  groupResults: GroupResult[];
  selectedAccountType: string;
  onSelect: (accountType: string) => void;
  remapStatuses?: RemapStatus[];
}

const TYPE_COLORS: Record<string, 'blue' | 'grey' | 'green' | 'red'> = {
  company: 'blue',
  individual: 'green',
  joint: 'grey',
  individualtrust: 'blue',
  corporatetrust: 'blue',
};

export default function AccountTypeSelector({
  groupResults,
  selectedAccountType,
  onSelect,
  remapStatuses,
}: AccountTypeSelectorProps) {
  return (
    <SpaceBetween direction="horizontal" size="xs" alignItems="center">
      <Box variant="span" fontSize="body-s" color="text-body-secondary">Groups:</Box>
      {groupResults.map((group) => {
        const isActive = group.accountType === selectedAccountType;
        const remapStatus = remapStatuses?.find(rs => rs.accountType === group.accountType);
        const isRemapping = remapStatus?.status === 'in-progress';
        const color = TYPE_COLORS[group.accountType] ?? 'grey';
        const mapped = group.mappings.filter(m => m.targetField !== 'unmapped').length;

        return (
          <span
            key={group.accountType}
            onClick={() => onSelect(group.accountType)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') onSelect(group.accountType); }}
            style={{
              cursor: 'pointer',
              opacity: isActive ? 1 : 0.7,
              borderBottom: isActive ? '2px solid #0972d3' : '2px solid transparent',
              paddingBottom: 2,
            }}
            aria-label={`Select ${group.accountType} group`}
            aria-pressed={isActive}
          >
            <Badge color={isRemapping ? 'red' : color}>
              {group.accountType} ({mapped}/{group.mappings.length})
              {isRemapping ? ' ⟳' : ''}
            </Badge>
          </span>
        );
      })}
    </SpaceBetween>
  );
}
